
import React from 'react'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'
import { formatDateLabel, sanitizeNotification, truncateText } from '../../lib/utils'

const typeStyles = {
  SUCCESS: {
    icon: <FontAwesome name="check-circle" className="notification-type-icon" />,
  },
  ERROR: {
    icon: <FontAwesome name="warning" className="notification-type-icon" />,
  },
  WARNING: {
    icon: <FontAwesome name="exclamation-circle" className="notification-type-icon" />,
  },
  INFO: {
    icon: <FontAwesome name="info-circle" className="notification-type-icon" />,
  },
}

const MAX_LENGTH = 120

export default class NotificationItem extends React.Component {

  state = {
    expanded: false,
  }

  toggleExpanded = () => {
    this.setState(prevState => ({ expanded: !prevState.expanded }))
  }

  render() {

    const { notification, onMarkRead, onDelete } = this.props,
    styleData = typeStyles[notification.type] || typeStyles.INFO,

    { expanded } = this.state,
    cleanedText = sanitizeNotification(notification.content),
    showReadMore = cleanedText && cleanedText.length > MAX_LENGTH

    return (
      <div className={ `notification-popover-item ${!notification.read ? 'notification-popover-item--unread' : 'notification-popover-item--read'}` }>

        {!notification.read && <span className="notification-unread-dot" />}

        <div className={ `notification-type-badge notification-type-badge--${notification.type.toLowerCase()}` }>{ styleData.icon }</div>

        <div className="notification-item-body">
          <h4 className={ `notification-item-title ${notification.read ? 'notification-item-title--read' : ''}` }>{ notification.title }</h4>
          { cleanedText && (
          <div>
            <div
              className="text-gray-600 text-xs"
              dangerouslySetInnerHTML={{ __html: expanded ? cleanedText : truncateText(cleanedText, MAX_LENGTH) }}
            />

            { showReadMore && (
              <button type="button" className="notification-read-more text-xs" onClick={ this.toggleExpanded }>
                { expanded ? 'Show less' : 'Read more' }
              </button>
            )}
          </div>
          )}
          <div className="notification-item-footer">
            <span className="notification-item-date"
              title={ notification.createdOn ? new Date(notification.createdOn).toLocaleString() : '' }>
              { notification.createdOn ? formatDateLabel(new Date(notification.createdOn.toLocaleString())) : '' }
            </span>

            <div className="notification-item-actions">
              { !notification.read && (
                <button type="button"
                  title='Mark as read'
                  className="rounded-full border-none py-8 px-12 bg-gray-100 hover:bg-gray-200 font-size-11 font-600 text-blue-600"
                  onClick={() => onMarkRead(notification.id)}
                >
                  <FontAwesome name="check" className='text-sm' /> Mark as read
                </button>
              )}

              <button type="button"
                title='Delete'
                className="rounded-full border-none py-8 px-12 bg-gray-100 hover:bg-gray-200 text-gray-600"
                onClick={() => onDelete(notification.id)}
                aria-label={`Delete ${ notification.title }`}
              >
                <FontAwesome name="trash" className='text-sm' />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    read: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['SUCCESS', 'ERROR', 'WARNING', 'INFO']).isRequired,
    createdOn: PropTypes.string.isRequired,
  }).isRequired,
  onMarkRead: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationItem.js